export default "__VITE_ASSET__DoD2NypI__"